import { Loading, useDynamicConfig } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { useParams } from "react-router";
import { eventService as sharedEventService } from "../../../shared/api/eventService";
import { mapEventToFormValues, prepareEventForDuplication } from "../../../shared/events/save/eventFormUtils";
import { SaveEvent } from "../../../shared/events/save/SaveEvent";
import { useEventSave } from "./useEventSave";

export const DuplicateEventPage: FC = () => {
	const { eventId = "", viewType = "" } = useParams();
	const handleSave = useEventSave(viewType);
	const { defaultCurrency } = useDynamicConfig();

	const { data: event, isLoading } = useQuery({
		queryKey: sharedEventService.showKey(eventId),
		queryFn: () => sharedEventService.show(eventId).then((x) => x.data.data),
	});

	if (isLoading || !event) {
		return <Loading />;
	}

	const initialValues = mapEventToFormValues(prepareEventForDuplication(event), defaultCurrency);

	return <SaveEvent variant="outlined" initialValues={initialValues} onSubmit={handleSave} />;
};
